<template>
  <div class="modal">
    <div class="modal__header modal__price">
      <div class="header__title">
        <span>결제금액</span>
        <span class="vat">(VAT 포함)</span>
      </div>
      <div class="header__price">
        <span
          v-if="!loadingStatus && getDeliveryOptions.isExpressDelivery !== null"
          >{{ getDeliveryOptions.totalOrderFee.toLocaleString() }}</span
        >
        <span v-else-if="getDeliveryOptions.isExpressDelivery === null">
          0
        </span>
        <i v-else class="fas fa-circle-notch fa-spin"></i>원
        <img
          :class="{ toggle__open: toggleOpen }"
          @click="toggleOpen = !toggleOpen"
          src="@/assets/img/order/Ic_input_dropdown.svg"
        />
      </div>
    </div>
    <div class="modal__body">
      <div style="width: 100%" v-if="toggleOpen">
        <div class="box__content">
          <div class="order-info"></div>
        </div>
        <feeList :deliveryOptions="getDeliveryOptions" />
        <div class="caution">
          <img class="caution-icon" src="@/assets/img/ic_notice_mypage.svg" />
          당일 외 예약접수 시 시간/기상/특수일(토,일,공휴일) 할증요금을
          빼드려요.
        </div>

        <div class="caution" v-show="getDeliveryOptions.vehicleItemCode === 2">
          <img class="caution-icon" src="@/assets/img/ic_notice_mypage.svg" />
          <div>화물차 배송의 경우 추가요금이 부과될 수 있어요.</div>
        </div>
      </div>
      <div class="final">
        <button
          :disabled="
            loadingStatus ||
            originTimeInvalid ||
            stepStatus < 5 ||
            getDeliveryOptions.calcUuid === ''
          "
          class="final__btn final__btn--cart"
          @click="$emit('placeOrder')"
        >
          {{ $route.params.flag === "update" ? "수정하기" : "장바구니 담기" }}
        </button>
        <button
          :disabled="
            loadingStatus ||
            originTimeInvalid ||
            stepStatus < 5 ||
            getDeliveryOptions.calcUuid === ''
          "
          class="final__btn final__btn--next"
          @click="$emit('openPayment')"
        >
          바로 주문
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import mixinOrder from "@/mixins/mixinOrder";
import mixinFilter from "@/mixins/mixinFilter";
import feeList from "@/components/common/feeList.vue";
import orderTag from "@/components/common/orderTag.vue";
export default {
  props: ["originTimeInvalid", "loadingStatus", "stepStatus"],
  mixins: [mixinOrder, mixinFilter],
  components: { feeList, orderTag },
  data() {
    return {
      toggleOpen: false
    };
  },
  methods: {}
};
</script>
<style src="./layout.css" scoped></style>
<style src="@/assets/css/newGlobal.css" scoped></style>
